import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { subscribeApiLoader } from "../core/common/api";

const SHOW_DELAY_MS = 100;

const GlobalLoader = () => {
  const [pending, setPending] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => subscribeApiLoader(setPending), []);

  useEffect(() => {
    if (pending === 0) {
      setVisible(false);
      return;
    }
    const timer = window.setTimeout(() => setVisible(true), SHOW_DELAY_MS);
    return () => window.clearTimeout(timer);
  }, [pending > 0]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!visible) return null;

  return createPortal(
    <div className="global-loader" role="status" aria-live="polite">
      <div className="global-loader__bar" />
      <div className="global-loader__spinner">
        <span className="global-loader__circle" />
        <span className="global-loader__text">Loading...</span>
      </div>
    </div>,
    document.body,
  );
};

export default GlobalLoader;
